import classes from "./ManagePage.module.scss";
import { Page } from "components/manage/Page";
import Select from "components/core/Select";

import { MANAGE_TABS, MANAGE_PAGE_SIZE, MANAGE_SORT_LIST, PUBLIC_LIST } from "utils/constants";
import PageActions from "components/UI/PageActions";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { ManageGifList } from "components/manage/ManageGifList";
import { useMeGifsQuery } from "queries";
import { IGif } from "services/types";
import { IUserGifsParams } from "services/RedGifsService";
import { Tabs } from "components/manage/Tabs";
import colors from "theme/themeConstants";
import { CircularProgress } from "@mui/material";
import { ManageFilterTags } from "components/manage/ManageFilterTags";
import { FooterAds } from "../../components/ads/FooterAds";

export const ManagePage = () => {
  const [gifs, setGifs] = useState<IGif[]>([]);
  const [pages, setPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [isTrigger, setIsTrigger] = useState(false);

  const [filters, setFilters] = useState<IUserGifsParams>({
    order: MANAGE_SORT_LIST[0].value,
    isPublic: PUBLIC_LIST[0].value,
    count: MANAGE_PAGE_SIZE[0].value,
    type: MANAGE_TABS[0].value,
    page: 1,
    tags: [],
  });

  const { isSuccess, isLoading, data } = useMeGifsQuery({ isTrigger, ...filters });

  const handleChangeType = useCallback((type: string) => {
    setFilters(prev => ({
      ...prev,
      page: 1,
      type
    }));
  }, []);

  const handleChangePageSize = useCallback((count: string | null) => {
    setFilters(prev => ({
      ...prev,
      page: 1,
      count
    }));
  }, []);

  const handleChangePage = useCallback((page: number) => {
    setFilters(prev => ({
      ...prev,
      page
    }));
  }, []);

  const handleChangeOrder = useCallback((order: string | null) => {
    setFilters(prev => ({
      ...prev,
      order
    }));
  }, []);

  const handleChangeVisibility = useCallback((isPublic: string | null) => {
    setFilters(prev => ({
      ...prev,
      page: 1,
      isPublic
    }));
  }, []);

  const handleChangeTags = useCallback((tags: string[]) => {
    setFilters(prev => ({
      ...prev,
      page: 1,
      tags
    }));
  }, []);

  const handleTrigger = useCallback(() => {
    setIsTrigger(prev => !prev);
  }, []);

  useEffect(() => {
    if (isSuccess && data && data.gifs.length === 0 && filters.page !== null && filters.page > 1) {
      setFilters(prev => ({
        ...prev,
        page: 1,
      }));
      return;
    }

    if (isSuccess && data) {
      setGifs(data.gifs);
      setPages(data.pages);
      setTotal(data.total);
      return;
    }

    setGifs([]);
    setPages(1);
    setTotal(0);
  }, [isSuccess, data, filters]);

  return (
    <Fragment>
      <Page title="Manage">
        <div className={classes.managePage}>
          <Tabs value={filters.type} list={MANAGE_TABS} onChange={handleChangeType}/>

          <ManageFilterTags addedTags={filters.tags} onChange={handleChangeTags} />

          <div className={classes.filtersSelect}>
            <div className={classes.sortVisibility}>
              <Select label="Sort By" value={filters.order} list={MANAGE_SORT_LIST} onChange={handleChangeOrder}/>
              <Select label="Visibility" value={filters.isPublic} list={PUBLIC_LIST} onChange={handleChangeVisibility}/>
            </div>
          </div>

          {
            isLoading && (
              <div style={{ display: "flex", justifyContent: "center", padding: "3rem" }}>
                <CircularProgress sx={{ color: colors.redPink }} size={32} />
              </div>
            )
          }

          {
            !isLoading && (
              <Fragment>
                <ManageGifList gifs={gifs} triggerQuery={handleTrigger} />
                {
                  isSuccess && pages > 1 ? (
                    <PageActions
                      pageSize={filters.count}
                      pageSizeList={MANAGE_PAGE_SIZE}
                      setPageSize={handleChangePageSize}
                      page={filters.page ?? 1}
                      pageCount={pages}
                      itemsCount={total}
                      setPage={handleChangePage}
                    />
                  ) : null
                }
              </Fragment>
            )
          }
        </div>
      </Page>
      <FooterAds/>
    </Fragment>
  );
};
